import { Form, OverlayTrigger, Popover } from 'react-bootstrap';
import InformationIcon from '../../assets/icons/info-bold.svg';
import RadioField from './radioField.js';
import CustomFieldError from './customFieldError.js';
import CommasToBullets from '../../utils/commasToBullets.js';

export default function RadioFieldResources({ label, ...props }) {
  const bulletedList = CommasToBullets(props.guidance);

  const popover = (
    <Popover id="popover-contained">
      <Popover.Header as="h3">{bulletedList}</Popover.Header>
    </Popover>
  );

  return (
    <>
      <Form.Group controlId={props.name}>
        <div key="inline-radio">
          <Form.Check.Label className="me-2 mb-1">
            <OverlayTrigger
              trigger={['hover', 'click', 'focus']}
              placement="top"
              overlay={popover}
            >
              <Form.Check.Label className="tool-hover mb-2">
                {label}{' '}
                <img
                  src={InformationIcon}
                  alt="information-icon"
                  className="icon-size"
                />
              </Form.Check.Label>
            </OverlayTrigger>
          </Form.Check.Label>
          <RadioField
            inline
            name={props.name}
            value="1"
            label="1"
            type="radio"
            disabled={props.processing}
            id="inline-radio-1"
          />
          <RadioField
            inline
            name={props.name}
            value={"2"}
            label="2"
            type="radio"
            disabled={props.processing}
            id="inline-radio-2"
          />
          <RadioField
            inline
            name={props.name}
            value="3"
            label="3"
            type="radio"
            disabled={props.processing}
            id="inline-radio-3"
          />
          <RadioField
            inline
            name={props.name}
            value="4"
            label="4"
            type="radio"
            disabled={props.processing}
            id="inline-radio-4"
          />
          <RadioField
            inline
            name={props.name}
            value="5"
            label="5"
            type="radio"
            disabled={props.processing}
            id="inline-radio-5"
          />
        </div>
      </Form.Group>
      <CustomFieldError name={props.name} />
    </>
  );
}
